'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OIDC_DISABLE_AUTO_SIGNIN_SIGNOUT_REDIRECT = exports.OIDC_DISABLE_AUTO_SIGNIN_SIGNOUT_REDIRECT = 'OIDC_DISABLE_AUTO_SIGNIN_SIGNOUT_REDIRECT';

/**
 * @param {boolean} oidcDisableAutoSigninRedirect
 * @param {boolean} oidcDisableAutoSignoutRedirect
 */
var oidcDisableAutoSigninSignoutRedirect = function oidcDisableAutoSigninSignoutRedirect() {
  var oidcDisableAutoSigninRedirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var oidcDisableAutoSignoutRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return {
    type: OIDC_DISABLE_AUTO_SIGNIN_SIGNOUT_REDIRECT,
    oidcDisableAutoSigninRedirect: oidcDisableAutoSigninRedirect,
    oidcDisableAutoSignoutRedirect: oidcDisableAutoSignoutRedirect
  };
};

exports.default = oidcDisableAutoSigninSignoutRedirect;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/oidc/actions/OidcDisableAutoSigninSignoutRedirect.js
// module id = 341
// module chunks = 10